"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateProductIfrs = exports.calculateShippingIfrs = void 0;
const interfaces_1 = require("../interfaces");
const defaultNoShow = 0.395;
const defaultMargin = 0.3332;
const taxRates = {
    TEST: 1.19,
    DE: 1.19,
    AT: 1.2,
    CH: 1.077,
};
const getNoShow = (product, appointment) => {
    if (appointment?.appointmentId || appointment?.locationId || appointment?.reservationId) {
        return 0;
    }
    return product.scoringFactor ? Number.parseFloat(product.scoringFactor.noShow) : defaultNoShow;
};
const getMargin = (product) => {
    return product.scoringFactor ? Number.parseFloat(product.scoringFactor.margin) : defaultMargin;
};
const getTaxRate = (tenant) => {
    const country = tenant.split('_')[1];
    return taxRates[country];
};
const getIfrs = ({ price, discount, noShow, margin, taxRate, offsetShare, quantity, }) => {
    return (((price - discount) * noShow + ((1 - noShow) * (price * margin - discount)) / taxRate) * quantity) -
        (((offsetShare * price - offsetShare * discount) * noShow + ((1 - noShow) * (offsetShare * price * margin - offsetShare * discount)) / taxRate) * quantity);
};
const calculateShippingIfrs = (tenant, price, offsetShare) => {
    return getIfrs({
        discount: 0,
        margin: 1,
        noShow: 0,
        quantity: 1,
        price,
        offsetShare,
        taxRate: getTaxRate(tenant),
    });
};
exports.calculateShippingIfrs = calculateShippingIfrs;
const calculateProductIfrs = ({ product, tenant, quantity, offsetShare, orderDiscountRate, appointment, }) => {
    const taxRate = getTaxRate(tenant);
    const margin = getMargin(product);
    const noShow = getNoShow(product, appointment);
    const price = product.price.gross.amount;
    const discount = !!product.productType &&
        interfaces_1.discountableProductTypes.includes(product.productType) &&
        !product.originalPrice
        ? orderDiscountRate * price
        : 0;
    return getIfrs({
        discount,
        margin,
        noShow,
        offsetShare,
        price,
        quantity,
        taxRate,
    });
};
exports.calculateProductIfrs = calculateProductIfrs;
//# sourceMappingURL=calculateProductIfrs.js.map